import React from "react";
import { Section, Field, TextIn, Tick } from "./obUi";

export const TermsSection = ({ a, set, ro, terms, admin }) => (
  <Section n={7} title="Lead terms & anything else" testId="ob-section-terms"
           hint={admin ? "Filling this in for the buyer? Tick the box only if they agreed to these terms, and type the name of the person who agreed." : "Please read and agree to the lead terms."}>
    <Field label="Lead terms" wide>
      <div className="border-2 border-black bg-zinc-50 p-4 max-h-64 overflow-y-auto text-xs whitespace-pre-wrap leading-relaxed" data-testid="ob-terms-text">
        {terms}
      </div>
    </Field>
    <Field wide label="">
      <Tick ro={ro} checked={a.terms_accepted} onChange={(v) => set("terms_accepted", v)} testId="ob-terms-accept">
        {admin ? "The buyer agreed to these lead terms." : "I agree to these lead terms."}
      </Tick>
    </Field>
    <Field label={admin ? "Name of the person who agreed" : "Type your full name"} required>
      <TextIn a={a} set={set} ro={ro} k="signature_name" testId="ob-signature" placeholder="Full name" />
    </Field>
    <Field label="Anything else we should know? (optional)" wide>
      <TextIn a={a} set={set} ro={ro} area k="notes" testId="ob-notes" />
    </Field>
  </Section>
);
